/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RequiresDiagnosis/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function RequiresDiagnosis({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/AddAction/Add/Content/RequiresDiagnosis",
  onChange
  
}) {
let procedureRequiresDiagnosisValueData = fromData.useDataValue({ viewPath,
context: 'procedure',
path: 'requires_diagnosis',
})
let procedureRequiresDiagnosisChangeData = fromData.useDataChange({ viewPath,
context: 'procedure',
path: 'requires_diagnosis',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="procedure.requires_diagnosis"
 value={procedureRequiresDiagnosisValueData}
 onChange={procedureRequiresDiagnosisChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Requires diagnosis"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}